const ACTIVATING_CLASS = "activating";
const DEACTIVATING_CLASS = "deactivating";

const ACTIVATE_CONTENT_TIME = 400;
const GO_TO_INDEX_TIME = 200;
const DEACTIVATE_CONTENT_TIME = 400;

/**
 * Content Slider class to object and add listeners to 
 * multiple content sliders
 */
export default class ContentSlider {

    /**
     * constructor for the class
     * @param {object} $element jquery element
     * @return {ContentSlider} this class
     */
    constructor($element) {
        //asign eelement
        this.el = $element;
        //get the index
        this.sliderIndex = $element.data('sliderindex');
        //get the key
        this.sliderKey = $element.data('sliderkey');
        //get the header elements
        this.headerItems = $element.find('.split-content-slider-nav-item');
        //get the content elements
        this.contentItems = $element.find('.split-content-slider-content-item');
        //current slider nav item
        this.sliderNavItem = this.headerItems.filter('.active');
    
        //for UX set up
        this.actionQueue = [];

        //attach listeners to triggers
        this.attachListeners();

        return this;
    }

    /**
     * Attach listeners
     * @return {null} nothing
     */
    attachListeners() {
        //primary trigger is on header item clicks
        this.headerItems.on('click', this.triggerEvent.bind(this));
    }

    /**
     * listener for trigger events
     * @param {object} event dom event
     * @return {null} nothing
     */
    triggerEvent(event) {
        const item = event.target;
        const $selectedItem = jQuery(item);

        //only trigger change if not active
        if (!$selectedItem.hasClass('active')) {
            //remove active for all nav items
            this.headerItems.removeClass('active');

            //find new slider, assign and set active
            this.sliderIndex = $selectedItem.data('triggerindex');
            this.sliderNavItem = this.headerItems.filter(`.nav-item-${this.sliderIndex}`);
            this.sliderNavItem.addClass('active');

            //process deactivation of content and move to new content
            this.deactivateContent()
                .goToIndex()
                .activateContent()
                .run();
        }
    }

    /**
     * deactivate content made for method chaining
     * @return {CoverVideo} reference to this object
     */
    deactivateContent() {
        //add deactivation to action queue
        this.actionQueue.push( {
            duration: DEACTIVATE_CONTENT_TIME,
            runAction: () => {
                this.contentItems
                    .filter('.active')
                    .addClass(DEACTIVATING_CLASS);
            }
        });
        return this;
    }

    /**
     * go to index content made for method chaining
     * @return {CoverVideo} reference to this object
     */
    goToIndex() {
        //remove activating, add activated
        this.actionQueue.push( {
            duration: GO_TO_INDEX_TIME,
            runAction: () => {
                this.contentItems
                    .filter('.active')
                    .removeClass('active')
                    .removeClass(DEACTIVATING_CLASS);
                this.contentItems
                    .filter(`.content-item-${this.sliderIndex}`)
                    .addClass(ACTIVATING_CLASS)
                    .addClass('active');
                this.el.attr('data-sliderindex', this.sliderIndex);
            }
        });
        return this;
    }

    /**
     * activate content made for method chaining
     * @return {CoverVideo} reference to this object
     */
    activateContent() {
        //remove activating
        this.actionQueue.push( {
            duration: ACTIVATE_CONTENT_TIME,
            runAction: () => {
                this.contentItems
                    .filter('.active')
                    .removeClass(ACTIVATING_CLASS);
            }
        });
        return this;
    }

    /**
     * primary method to run through the action queue
     * @return {null} nothing
     */
    run() {
        //execute the action queue if exists and assign delay
        if (this.actionQueue.length > 0) {
            var thisAction = this.actionQueue.shift();
            thisAction.runAction();

            //set up next action
            setTimeout(() => {
                this.run();
            }, thisAction.duration)
        }
    }
}